import {
    Armchair,
    Shirt,
    Music,
    Palette,
    Utensils,
    Zap,
    Gamepad2,
    Gem,
    Package
} from "lucide-react";

interface CategoryIconProps {
    category: string;
    className?: string;
    size?: number;
}

export const categoryIconMap: Record<string, any> = {
    "Meubels": Armchair,
    "Kleding & Schoenen": Shirt,
    "Boeken & Media (LP's, CD's)": Music,
    "Woondecoratie & Kunst": Palette,
    "Keuken- & Huishoudelijk": Utensils,
    "Elektronica (klein)": Zap,
    "Speelgoed & Spellen": Gamepad2,
    "Sieraden & Accessoires": Gem,
};

export function CategoryIcon({ category, className = "", size = 16 }: CategoryIconProps) {
    const Icon = categoryIconMap[category] || Package;

    return <Icon className={className} size={size} />;
}
